<template>
  <section class="faq-section">
    <div class="faq">
      <v-landing-container small>
        <h2 class="faq__title">{{ $t('v.home.accordionTitle') }}</h2>
        <ul class="faq__list">
          <li v-for="content in contents" :key="content.id" class="faq__item">
            <faq-item
              :question="content.question"
              :description="content.description"
              :is-open="current === content.id"
              :id="content.id"
              @toggle="toggle"
            />
          </li>
        </ul>
      </v-landing-container>
    </div>
  </section>
</template>

<script>
import FaqItem from '@/components/Landing/Home/FAQItem.vue'
import VLandingContainer from '@/components/Landing/VLandingContainer.vue'

export default {
  name: 'HomeFaq',

  components: {
    VLandingContainer,
    FaqItem
  },

  data() {
    return {
      contents: [
        {
          question: this.$t('v.home.question1'),
          description: this.$t('v.home.answer1'),
          id: 0
        },
        {
          question: this.$t('v.home.question2'),
          description: this.$t('v.home.answer2'),
          id: 1
        },
        {
          question: this.$t('v.home.question3'),
          description: this.$t('v.home.answer3'),
          id: 2
        },
        {
          question: this.$t('v.home.question4'),
          description: this.$t('v.home.answer4'),
          id: 3
        }
      ],
      current: null
    }
  },
  methods: {
    toggle(id) {
      if (this.current !== id) this.current = id
      else this.current = null
    }
  }
}
</script>

<style lang="scss">
@import "../../../assets/style/scss/vars";
@import "../../../assets/style/scss/extends";

h2 {
  margin: 0;
}

.faq-section {
  background-color: $blue;
  background-image: url(/bg_wave.svg);
  background-repeat: no-repeat;
  background-size: contain;
  padding-bottom: 153px;
  padding-top: 16%;
}

.faq__title {
  text-align: center;
  font-family: $font-gilroy;
  font-weight: map-get($font-weight, "extra-bold");
  font-size: 40px;
  letter-spacing: -0.04em;
  color: $white;
  margin-bottom: 62px;
}

.faq__list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.faq__item {
  border-bottom: 1px solid $white;
  &:first-child {
    border-top: 1px solid $white;
  }
}
</style>
